export default "__VITE_ASSET__f5fa2305__"